import React from "react";
import ParentTeacherPortal from "../ParentTeacher/ParentTeacherPortal";
export default function ParentPortal() { return <ParentTeacherPortal forcedAudience="parent" />; }
